import { VALID } from 'common/const';

const FIELD = {
  address1: {
    label: 'Address 1',
    placeholder: 'Street Number, Street Name, etc',
    validation: VALID.ADDRESS.required('Address is required'),
  },
  address2: {
    label: 'Address 2',
    placeholder: 'Locality, Neighbourhood, etc',
    validation: VALID.ADDRESS_2.required('Address 2 is required'),
  },
  city: {
    label: 'City or District',
    validation: VALID.CITY.required('City or district is required'),
  },
  zip: {
    label: 'Postal Code',
    validation: VALID.POSTAL_CODE.required('Postal code is required'),
  },
  state: {
    label: 'State',
    validation: VALID.STATE.required('State is required'),
  },
};

export default FIELD;
